import React from 'react';
import moment from 'moment';
import { FaCar, FaWalking, FaBicycle, FaRoute, FaMapMarkerAlt, FaFlagCheckered } from 'react-icons/fa';

const formatDuration = (seconds) => {
    if (!seconds) return '0m';
    const d = moment.duration(seconds, 'seconds');
    if (d.asHours() >= 1) return `${Math.floor(d.asHours())}h ${d.minutes()}m`;
    return `${d.minutes()}m`;
};

const TripDetails = ({ trip }) => {
    if (!trip) return null;

    const { stats, origin, destination, tripType, startTime, endTime } = trip;
    const TripIcon = tripType === 'walking' ? FaWalking : tripType === 'cycling' ? FaBicycle : FaCar;

    return (
        <div className="trip-details-card">
            <div className="trip-details-header">
                <TripIcon size={22} color="#343a40" />
                <h3>Trip Details</h3>
            </div>
            <div className="trip-details-body">
                <div className="trip-stats">
                    <div className="stat-item">
                        <span className="stat-label">Distance</span>
                        <span className="stat-value">{stats.distance.toFixed(2)} km</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-label">Duration</span>
                        <span className="stat-value">{formatDuration(stats.duration * 60)}</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-label">Avg Speed</span>
                        <span className="stat-value">{stats.averageSpeed.toFixed(1)} km/h</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-label">Max Speed</span>
                        <span className="stat-value">{stats.maxSpeed.toFixed(1)} km/h</span>
                    </div>
                </div>
                <div className="trip-endpoints">
                    <div className="endpoint">
                        <FaMapMarkerAlt className="endpoint-icon" />
                        <div className="endpoint-info">
                            <p className="endpoint-address">{origin?.placeAddress || 'N/A'}</p>
                            <p className="endpoint-time">{moment(startTime).format('hh:mm A')}</p>
                        </div>
                    </div>
                    <div className="endpoint">
                        <FaFlagCheckered className="endpoint-icon" />
                        <div className="endpoint-info">
                            <p className="endpoint-address">{destination?.placeAddress || 'N/A'}</p>
                            <p className="endpoint-time">{moment(endTime).format('hh:mm A')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TripDetails; 